import axios, { AxiosPromise } from 'axios';

const validateToken = (token: string): AxiosPromise =>
  axios.post('api/accounts/validate', null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export default validateToken;
